import { render } from "./text-area.vue?vue&type=template&id=1b12c366"
import script from "./text-area.vue?vue&type=script&setup=true&lang=js"
export * from "./text-area.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/form/text-area.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b12c366"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b12c366', __exports__)) {
    console.log('reload')
    api.reload('1b12c366', __exports__)
  }
  
  module.hot.accept("./text-area.vue?vue&type=template&id=1b12c366", () => {
    console.log('re-render')
    api.rerender('1b12c366', render)
  })

}


export default __exports__